module.exports = __webpack_public_path__ + "static/media/cng-epapers.6af11b57.png";